import React from 'react';
import Carousel from '../../CreationLanderShared/Carousel';
import MiniCard from '../MiniCard';
import styles from './index.module.scss';


/**
 * Determines the package type based on package_feed.name
 * @param {Object} packageData - The package content object
 * @returns {'challenge' | 'editorial'} The package type
 */
export const getPackageType = (packageData) => {
  const feedName = packageData?.package_feed?.name || '';
  if (feedName === 'feed_for_challenge_carousel') {
    return 'challenge';
  }
  return 'editorial';
};


/**
 * Package component for rendering collections of generators
 * Supports two types: challenge packages and general packages
 */
const Package = ({ packageData, index, isWeb, onWebNavigate, currentZoneName, zoneOrder }) => {
  const idKey = packageData?.id != null ? String(packageData.id) : undefined;
  const packageType = getPackageType(packageData);
  const items = packageData?.package_feed?.items || [];
  const packageId = packageData?.id;

  if (!items.length) {
    return null;
  }

  // Editorial packages render as a 2x2 grid of MiniCards
  if (packageType === 'editorial') {
    return (
      <div
        key={idKey || index}
        className={`${styles.package} ${styles['package--editorial']} ${isWeb ? styles.web : ''}`}
      >
        {items.map((item, idx) => (
          <MiniCard
            key={item?.id || idx}
            item={item}
            isWeb={isWeb}
            onWebNavigate={onWebNavigate}
            currentZoneName={currentZoneName}
            zoneOrder={zoneOrder}
            packageId={packageId}
            packageIndex={index}
            itemIndex={idx}
          />
        ))}
      </div>
    );
  }

  // Challenge packages render as a carousel
  return (
    <div
      key={idKey || index}
      className={`${styles.package} ${styles['package--challenge']}`}
    >
      <Carousel
        items={items}
        packageType={packageType}
        isWeb={isWeb}
        onWebNavigate={onWebNavigate}
        currentZoneName={currentZoneName}
        zoneOrder={zoneOrder}
        packageId={packageId}
        packageIndex={index}
      />
    </div>
  );
};

export default React.memo(Package, (prevProps, nextProps) => {
  return (
    prevProps.index === nextProps.index &&
    prevProps.packageData?.id === nextProps.packageData?.id &&
    prevProps.packageData === nextProps.packageData
  );
});
